module.exports = __webpack_public_path__ + "img/chr_ts_90_12.6351ef80.png";